var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactCheckBlack24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "22px",
    viewBox: "0 0 26 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icons/Action/assignment_ind_black_24dp 2")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tablet-View/Navigation/Side-nav_Help",
    transform: "translate(-19.000000, -299.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(0.000000, 278.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.333333, 17.333333)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 29.3333335,
    height: 29.3333335
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.444444, 3.666667)",
    fill: "#232323",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,0 L2.44444446,0 C1.10000001,0 0,1.1 0,2.44444446 L0,19.5555556 C0,20.9000001 1.10000001,22 2.44444446,22 L22,22 C23.3444446,22 24.4444446,20.9000001 24.4444446,19.5555556 L24.4444446,2.44444446 C24.4444446,1.1 23.3444446,0 22,0 Z M22.0000001,19.5555556 L2.44444446,19.5555556 L2.44444446,2.44444446 L22.0000001,2.44444446 L22.0000001,19.5555556 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "21.278889 9.06888893 19.5433334 7.33333337 15.668889 11.2077778 13.9455556 9.47222227 12.2222223 11.1955556 15.668889 14.6666667"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.66666668,
    y: 4.88888891,
    width: 6.11111114,
    height: 2.44444446
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.66666668,
    y: 9.77777782,
    width: 6.11111114,
    height: 2.44444446
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.66666668,
    y: 14.6666667,
    width: 6.11111114,
    height: 2.44444446
  }))))))));
}
export default SvgFactCheckBlack24Dp;